import { keymap } from 'prosemirror-keymap';

import { toggleTooltip } from '../commands';

const linkKeymap = keymap({
	'Mod-k': toggleTooltip,
});

export default linkKeymap;
